























import { Component, Vue, Watch } from 'vue-property-decorator';
import Spinner from './components/generic/Spinner.vue';
import Home from './components/Home.vue';
import Welcome from './components/Welcome.vue';
import Toaster from './components/Toaster.vue';
import { getModule } from 'vuex-module-decorators';
import MainModule from './store/modules/MainModule';
import { User, Credentials, AuthenticatableSource } from 'ganttlab-entities';
import LocalForage, {
  getRememberedCredentials,
  getRememberedSource,
} from './helpers/LocalForage';
import { getBySlug } from './helpers/ImplementedSourcesGateways';
import { SignIn } from './helpers/SignIn';
import { trackInteractionEvent } from './helpers/GTM';

const mainState = getModule(MainModule);

@Component({
  components: {
    Spinner,
    Home,
    Welcome,
    Toaster,
  },
})
export default class App extends Vue {
  private bypassWelcome = true;

  get justLoggedOut(): boolean {
    return mainState.justLoggedOut;
  }

  get user(): User | null {
    return mainState.user;
  }

  @Watch('user')
  onUserChange(user: User | null) {
    if (user && !this.justLoggedOut) {
      // user is set, let's proceed!
      this.bypassWelcome = false;
    }
  }

  async mounted() {
    if (this.justLoggedOut) {
      this.bypassWelcome = false;
      return;
    }

    // when mounted, fill vuex store with remembered data
    mainState.setCredentialsBySource(await getRememberedCredentials());
    mainState.setRemember(await LocalForage.getItem('remember'));

    // if a remembered state allows for logging in, just do it now!
    const latestSource = await getRememberedSource();
    if (mainState.remember && latestSource) {
      const credentials: Credentials | null = mainState.getSourceCredentials(
        latestSource,
      );
      if (credentials) {
        const sourceGateway = getBySlug(latestSource);
        if (sourceGateway) {
          if (sourceGateway instanceof AuthenticatableSource) {
            await SignIn(sourceGateway, credentials);
          } else {
            mainState.setSourceGateway(sourceGateway);
          }
          trackInteractionEvent(
            'Authentication',
            'Bypassed Welcome',
            sourceGateway.slug,
          );
          this.bypassWelcome = false;
        }
      }
    } else {
      this.bypassWelcome = false;
    }
  }
}
